import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import { toggleDarkMode } from 'actions/isDarkModeEnabled';

interface IsDarkModeEnabledState {
    isDarkModeEnabled: boolean;
}

const initialState: IsDarkModeEnabledState = {
    isDarkModeEnabled: false,
};

const handleIntitaliseTheme = (
    state: IsDarkModeEnabledState,
    action: PayloadAction<IsDarkModeEnabledState['isDarkModeEnabled']>,
) => {
    state.isDarkModeEnabled = action.payload;
};

export default createReducer(initialState, builder => {
    builder.addCase(toggleDarkMode, handleIntitaliseTheme);
});
